/**
 *
 * ListTaxes
 *
 */
import { memo, useState } from 'react';

import { type HookFormMethods, HookFormResolver, PageTitle } from '@dec/shared';
import { Col, Row } from '@dec/shared';
import { Button } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { Number } from '@dec/shared';
import { Text } from '@dec/shared';
import { BtnGroup } from '@dec/shared';
import { BtnToolbar } from '@dec/shared';
import { type ColDef } from 'ag-grid-community';
import { ActionsGrid } from 'app/components/grid';
import { type ActionColumn } from 'app/components/grid/actions-column';
import { factoryYup, limit } from 'app/core/factory-yup';
import * as Icon from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import GridApplication from '../../../../../components/grid/gridApplication';
import { type Report } from '../../models/types';
import { BaseUrlReports } from '../../services/http';
import { headers, title } from '../../translation';
const yup = factoryYup();

const validations = yup.object().shape({
  shortName: yup.string().max(limit.maxUserName),
  name: yup.string().max(limit.maxName),
  code: yup.number().nullable().max(999999)
});
// eslint-disable-next-line react/display-name
export const ListReport = memo(() => {
  return <ListOfReports />;
});

interface SearchTaxes {
  name?: string;
  code?: number;
  shortCode?: string;
}

function ListOfReports() {
  const [search, setSearch] = useState<SearchTaxes>({});
  const { t } = useTranslation();

  const navigate = useNavigate();

  const gotToEdit = (id: string) => {
    navigate(`/taxes/manage/complementary/${id}/general`);
  };

  const onSearch = (values: SearchTaxes) => {
    setSearch(values);
  };

  const actions: Array<ActionColumn> = [
    {
      icon: Icon.PencilSquare,
      variant: 'primary',
      onClick: (row: Report) => {
        gotToEdit(row.id as string);
      }
    }
  ];
  const colDef: Array<ColDef> = [
    {
      headerName: headers(t, 'actions'),
      cellRenderer: ActionsGrid,
      cellRendererParams: {
        actions: actions
      }
    },
    { headerName: headers(t, 'code'), field: 'code' },
    {
      headerName: headers(t, 'shortName'),
      field: 'shortName'
    },
    { headerName: headers(t, 'name'), field: 'name' }
  ];

  const newReport = () => {
    navigate(`/taxes/manage/complementary/create`);
  };

  return (
    <>
      <PageTitle title={title(t, 'page')} />
      <HookFormResolver
        onSubmit={onSearch}
        validations={validations}
        initialValues={{ name: null }}
      >
        {({ formState: { errors }, reset, setValue, control }: HookFormMethods) => {
          return (
            <>
              <Row>
                <Col>
                  <Number label={headers(t, 'code')} name="code" />
                </Col>

                <Col>
                  <Text label={headers(t, 'shortName')} name="shortName" />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Text label={headers(t, 'name')} name="name" />
                </Col>

                <Col />
              </Row>

              <BtnToolbar>
                <BtnGroup>
                  <Button
                    action={ButtonAction.clean}
                    type={'reset'}
                    onClick={() => {
                      reset({ code: null });
                      setSearch({});
                    }}
                  />
                </BtnGroup>
                <BtnGroup>
                  <Button action={ButtonAction.new} onClick={newReport} />
                  <Button action={ButtonAction.find} type={'submit'} variant={'primary'} />
                </BtnGroup>
              </BtnToolbar>
            </>
          );
        }}
      </HookFormResolver>
      <hr />
      <Row>
        <Col>
          <GridApplication url={BaseUrlReports} columnDefs={colDef} search={search} />
        </Col>
      </Row>
    </>
  );
}

export default ListReport;
